/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

/**
 * Retrieve a number of thumb position in percentage (0..100) based on difference mouse or touch position to a container.
 */
export function getThumbPosition(mouseXPosition: number, containerLeft: number, containerWidth: number): number {
    const positionOffset = mouseXPosition - containerLeft;
    const position = positionOffset / containerWidth * 100;

    if (position < 0) {
        return 0;
    }
    return position > 100 ? 100 : position;
}

/**
 * Gives an x coordinates from the given mouse or touch move event.
 */
export function getCoordinatesFromMoveEvent(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
        return event.clientX;
    }
    const touches = (event as TouchEvent).targetTouches;
    return touches[0] ? touches[0].clientX : -1;
}
